import { DEFAULT_FILE_NAME } from '@debbie/common/dist/constants.js';
import { TemplateType } from '@debbie/common/dist/templates/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as filesAPI from '@debbie/cortex/dist/api/files.js';
import * as templatesAPI from '@debbie/cortex/dist/api/templates.js';
import { selectAuthToken } from '@debbie/cortex/dist/auth/selectors.js';
import { useNewInteraction } from '@debbie/cortex/dist/newInteractions/index.js';
import { useTenantId } from '@debbie/cortex/dist/tenant/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { APIBASE } from '../../config.js';
import { errorNotification } from '../../utils/errors.js';
import { parseText } from '../../utils/templates.js';
import { Button, Modal } from '../index.js';
import TemplateSearch from './TemplateSearch.js';
const AddFromTemplate = (props) => {
    const { case: singleCase, toggleAddTemplateModal, customer } = props;
    const lang = useSelector((s) => s.lang);
    const tenantId = useTenantId();
    const authToken = useSelector(selectAuthToken);
    const [interaction, setInteraction] = useNewInteraction(singleCase.caseId);
    const letter = interaction?.letter;
    const fetchPdfAsBase64 = async () => {
        const response = await fetch(`${APIBASE}/v1/${tenantId}` +
            templatesAPI.pdfPreviewURL(letter.templateId, singleCase.caseId, parseText(letter.content, props.mentionSuggestions)), {
            headers: authToken != ''
                ? {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authToken}`,
                    'X-Debbie-Auth-Token': authToken,
                }
                : {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                },
        });
        if (!response.ok) {
            throw new Error(`Failed to fetch PDF: ${response.status} ${response.statusText}`);
        }
        // Get PDF as ArrayBuffer
        const arrayBuffer = await response.arrayBuffer();
        // Convert to Base64
        const base64String = arrayBufferToBase64(arrayBuffer);
        // Optional: prefix with data URL
        const base64DataUrl = base64String;
        return base64DataUrl;
    };
    const adder = useMutation(async () => {
        const pdfString = await fetchPdfAsBase64();
        const file = await filesAPI.save({
            contentType: 'application/pdf',
            content: pdfString,
            name: letter.templateFileName || DEFAULT_FILE_NAME,
        });
        return file;
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'create', lang.errorEntities.attachment);
        },
        onSuccess: (file) => {
            toggleAddTemplateModal();
            setInteraction('uploadedFiles', [
                ...interaction.uploadedFiles,
                file.file,
            ]);
        },
    });
    return (React.createElement(Modal, { header: lang.interactions.addTemplate, maxWidth: "500px", onToggle: toggleAddTemplateModal },
        React.createElement(TemplateSearch, { interaction: letter, templateType: TemplateType.LETTER, case: singleCase, customer: customer }),
        React.createElement(Button, { loading: adder.isLoading, disabled: !letter.templateId, block: true, onClick: () => adder.mutate() }, lang.interactions.addTemplate)));
};
export default AddFromTemplate;
const arrayBufferToBase64 = (buffer) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
};
//# sourceMappingURL=AddFromTemplate.js.map